import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { StateService } from 'src/app/services/states.service';
import { AppService } from 'src/app/services/app.service';
import { CustomerService } from 'src/app/services/customer.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { MessValidemail } from '../../views/dialogs-messages/mess_validemail_dialog.component';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  login:string = "";
  password:string = "";
  forgetPass:boolean = false;
  message:string = "";
  messagefalse: string = "";
  invalidmail: boolean = false;
  tokenForMail: any;

  constructor(
      public dialogRef: MatDialogRef<LoginComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      public stateService: StateService,
      public appService: AppService,
      private router: Router,
      private cookies: CookieService,
      public dialog: MatDialog,
      private customerService : CustomerService,
    ) { }

  ngOnInit() {
    window['tryga']('send', 'event', 'connexion', 'se_connecter', '', '');
  }

  connexion() {
    window['tryga']('send', 'event', 'connexion', 'connexion', '', '');
    this.appService.getConnectToken().subscribe((res) => {
      environment.tokencsrf = res.result.token;
      this.logIn();
    });
  }
  closeDialog() {
    this.dialogRef.close();
  }
  logIn() {
    this.appService.login(this.login, this.password).subscribe((res) => {
      if(res.result.connect && res.result.connect === "OK"){
        environment.tokenauth = res.result.token; // #1624/#1631
        //console.log(res.result.user);
        res.result.user.credits = res.result.credits;
        res.result.user.identity.ID = res.result.user.ID;
        this.stateService.updateUser(res.result.user.identity);
        environment.tokencsrf = "";
        console.log('TOKEN ==>', res)
        environment.tokencalc = res.result.token_calc;
        this.cookies.set("Tokenauth", res.result.token);
        if(!this.data|| (this.data && !this.data.urlBack )){
          this.router.navigateByUrl("/dossier");
        }
        this.dialogRef.close();
      }else if(res.result.message){
        this.messagefalse = res.result.message;
        if(res.result.invalidmail && res.result.token){
          this.invalidmail = res.result.invalidmail;
          this.tokenForMail = res.result.token;
          
        }
      }
    });
  }
  sendMailValid(){
    this.appService.confirmEmail(this.login, this.tokenForMail).subscribe((response)=>{
      this.messagefalse = "";
      this.invalidmail = false;
      //console.log(response);
      let mess = ""
      if(response.success == false){
        mess = response.message;
      }
      const dialogRef = this.dialog.open(MessValidemail, {
        width: '100%',
        panelClass:'message-dialog',
        data: {
          "email": this.login,
          "message" : mess
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        this.router.navigateByUrl("/homepage");
      });
    });
  }

  forgetPassword(step){
    if(step === 1){
      this.forgetPass = true;
    }else if(step === 2){
      window['tryga']('send', 'event', 'connexion', 'mot_de_passe_oublie', '', '');
      this.appService.forgetpass(this.login).subscribe((response)=> {
        //(response);
        if(response && response.success){
          this.message = "Un email vient de vous être envoyé.";
        }else if(response && response.message){
          this.message =  response.message;
          console.log("Erreur envoie mail mot de passe : ",response.log)
        }else{
          this.message ="Une erreur est survenue. Veuillez réessayer.";
        }
      })
    }
  }
}
